// --- Message types for worker communication ---

export const MSG = {
	INIT: "init",
	CONVERT: "convert",
	READY: "ready",
	RESULT: "result",
} as const;

// --- Image formats ---

export const FORMAT = {
	JPEG: "jpeg",
	JPG: "jpg",
	PNG: "png",
	WEBP: "webp",
	AVIF: "avif",
	HEIC: "heic",
	HEIF: "heif",
	TIFF: "tiff",
	TIF: "tif",
	BMP: "bmp",
	GIF: "gif",
} as const;

// --- File status ---

export const FILE_STATUS = {
	PENDING: "pending",
	PROCESSING: "processing",
	COMPLETED: "completed",
	ERROR: "error",
} as const;

export type FileStatus = (typeof FILE_STATUS)[keyof typeof FILE_STATUS];

// --- Format mappings ---
export const EXTENSION_TO_FORMAT: Record<string, string> = {
	jpg: FORMAT.JPEG,
	jpeg: FORMAT.JPEG,
	png: FORMAT.PNG,
	webp: FORMAT.WEBP,
	avif: FORMAT.AVIF,
	heic: FORMAT.HEIC,
	heif: FORMAT.HEIF,
	tiff: FORMAT.TIFF,
	tif: FORMAT.TIFF,
	bmp: FORMAT.BMP,
	gif: FORMAT.GIF,
};

export const MIME_TO_FORMAT: Record<string, string> = {
	"image/jpeg": FORMAT.JPEG,
	"image/png": FORMAT.PNG,
	"image/webp": FORMAT.WEBP,
	"image/avif": FORMAT.AVIF,
	"image/heic": FORMAT.HEIC,
	"image/heif": FORMAT.HEIF,
	"image/tiff": FORMAT.TIFF,
	"image/bmp": FORMAT.BMP,
	"image/gif": FORMAT.GIF,
};

export const IMAGE_EXTENSIONS = new Set(Object.keys(EXTENSION_TO_FORMAT));

// --- Worker / pool config ---

export const WORKER_PATH = "/workers/image-converter-worker.js";
export const MAX_WORKERS = 8;
export const DEFAULT_WORKERS = 4;

// --- Conversion constants ---
export const DEFAULT_FORMAT = FORMAT.JPEG;

// --- UI constants ---
export const DOWNLOAD_STAGGER_MS = 200;
export const ZIP_FILENAME = "converted-images.zip";
